export default __webpack_public_path__ + "static/tree-wrapper-2-9fe6de2c27c435ca68f86ee4fb52e864.png";